import React, { createContext, useContext, useState } from "react";

const ConfettiContext = createContext();

export const useConfetti = () => {
    const context = useContext(ConfettiContext);
    if (!context) {
        throw new Error('useConfetti must be used within a ConfettiProvider');
    }
    return context;
};

export const ConfettiProvider = ({ children }) => {
    const [showConfetti, setShowConfetti] = useState(false);

    const triggerConfetti = (duration = 5000) => {
        setShowConfetti(true);
        setTimeout(() => {
            setShowConfetti(false);
        }, duration);
    };

    return (
        <ConfettiContext.Provider value={{ showConfetti, triggerConfetti }}>
            {children}
        </ConfettiContext.Provider>
    );
};
